<template>
  <transition name="fade">
    <div class="page-loading" v-if="loading">
      <div class="center">
        <v-progress-circular style="margin:auto" :size="80" width="6"
          indeterminate color="primary" />
      </div>
    </div>
  </transition>
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator'

@Component
export default class LoadingMask extends Vue {
  @Prop(Boolean) loading
}
</script>

<style lang="scss">
.page-loading {
  position: absolute;
  top: 0; left: 0; right: 0; bottom: 0;
  line-height: 100%;
  z-index: 100;
  background-color: white;
  .center {
    position: absolute;
    top: 50%; left: 50%;
    margin-top: -40px;
    margin-left: -40px;
  }
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .3s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>
